import { CRUDEntity } from "../abstracts/CRUDEntity";


export class Payments extends CRUDEntity {
    constructor(id=null){
        super();
        this.entityClass = 'payment';
        this.urlRoot = '/payments';
        this.sectionRootUrl = '/payments';
        this.id = id;
    }
}
